import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';
import { humanResourcesAccionesRoles } from '../../acciones-roles/administracion/human-resources.roles';
import { hrAccionesRoles } from '../../acciones-roles/departamentos/hr-acciones-roles';

export const HumanResourcesRoutes: SideBarButton = {
  data: {
    name: 'Recursos Humanos',
    appendUrl: './users',
    roles: [...humanResourcesAccionesRoles.routerActions.root],
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Personal',
        url: '',
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Competencias',
        overWriteUrl: 'competences',
        roles: [...humanResourcesAccionesRoles.sideNavActions.competenceList],
        otherUrls: ['/info/packing-box/:id', '/info/pallet/:id'],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Matriz',
        overWriteUrl: 'competences/matriz',
        roles: [...humanResourcesAccionesRoles.sideNavActions.matriz],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Tareas',
        url: '/tasks',
        roles: [
          ...humanResourcesAccionesRoles.sideNavActions.validateCompetence,
        ],
        otherUrls: ['/pallet/:teamId', '/pallet/:teamId/:palletId'],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Métricos',
        overWriteUrl: 'hr',
        roles: [...hrAccionesRoles.sideNavActions.root],
      },
      options: PreConfigButton3,
    },
  ],
};
